// resizeImage resizes the given image in place
export async function resizeImage(input: HTMLImageElement, width: number): Promise<HTMLImageElement> {
    const oldWidth = input.width;
    const oldHeight = input.height;
    const newHeight = Math.floor(oldHeight / oldWidth * width);

    // Create a temporary canvas to draw the downscaled image on.
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = newHeight;

    // Draw the down scaled image on the canvas and return the new data URL.
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    ctx.drawImage(input, 0, 0, width, newHeight);
    const newDataUrl = canvas.toDataURL();

    input.src = newDataUrl;
    const prom = (resolve: (i: HTMLImageElement) => void) => {
        input.onload = () => {
            resolve(input);
        };
    };

    return await new Promise(prom).then();
}

export function imageToCanvas(image: HTMLImageElement): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    // Draw the down scaled image on the canvas and return the new data URL.
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    ctx.drawImage(image, 0, 0, image.width, image.height);
    return canvas;
}

export async function getAsFile(
    input: HTMLImageElement | HTMLCanvasElement,
    fileName: string, type: ImageType, quality: number,
): Promise<File> {
    let canvas: HTMLCanvasElement;
    if (input instanceof HTMLImageElement) {
        canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
        ctx.drawImage(input, input.width, input.height);
    } else {
        canvas = input;
    }

    const buildBlob = (resolve: (f: File) => void) => {
        canvas.toBlob((blob) => {
            const b = blob as Blob;
            const jsFile = new File([b], fileName, { type, lastModified: Date.now() });

            resolve(jsFile);
        }, type, quality);
    };

    let ret: any;
    ret = await new Promise(buildBlob).then();

    return ret;
}

export async function buildImageFromURL(url: string): Promise<HTMLImageElement> {
    const img = document.createElement('img');
    img.src = url;
    const prom = (resolve: (i: HTMLImageElement) => void) => {
        img.onload = () => {
            resolve(img);
        };
    };

    return await new Promise(prom).then();
}

export enum ImageType {
    PNG = 'image/png',
    JPEG = 'image/jpeg',
    WEBP = 'image/webp',
}
